import { Tag, TagCloseButton, TagLabel } from "@chakra-ui/react";
import { useCallback } from "react";
import { Category } from "../../utils/vtt";

type Props = {
  category: Category;
  onDelete?: (category: Category) => void;
};

export default function CategoryItem({ category, onDelete }: Props) {
  const _onDelete = useCallback(() => {
    onDelete?.(category);
  }, [category, onDelete]);

  return (
    <Tag size="lg" variant="subtle" bg={category.color}>
      <TagLabel>
        {category.style === "bold" ? (
          <strong>{category.name}</strong>
        ) : category.style === "italic" ? (
          <em>{category.name}</em>
        ) : (
          category.name
        )}
      </TagLabel>
      {onDelete && <TagCloseButton onClick={_onDelete} />}
    </Tag>
  );
}
